import { addToDataLayer } from '../../components/tracking/gtm/utils';
import { TrackingEventName, GrcCustomerState, GrcInteraction, GrcPageType } from './types';

/**
 * GRC interactions
 *
 * =============
 * SAMPLE USAGE:
 * =============
 *
 * import { trackGrc } from '.../web/libs/tracking/grc';
 *
 * trackGrc({
 *   customerState: GrcCustomerState.Valid,
 *   interaction: GrcInteraction.LoyaltyBanner,
 *   pageType: GrcPageType.Landing,
 * })
 */

type GrcInteractionData = {
  event: TrackingEventName;
  grc_customer_state?: GrcCustomerState;
  grc_interaction?: GrcInteraction;
  grc_page_type?: GrcPageType;
};

type GrcInteractionProps = {
  customerState?: GrcCustomerState;
  interaction?: GrcInteraction;
  pageType?: GrcPageType;
};

export function trackGrc({ customerState, interaction, pageType }: GrcInteractionProps) {
  const data: GrcInteractionData = {
    event: TrackingEventName.grcInteraction,
  };

  if (customerState) data.grc_customer_state = customerState;
  if (interaction) data.grc_interaction = interaction;
  if (pageType) data.grc_page_type = pageType;

  addToDataLayer(data);
}
